"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IB_STOPPING = exports.IB_SET_STATE = exports.IB_SET_SPECIAL = exports.IB_RESET_SPECIAL = exports.GameInfoBarState = void 0;
var IB_RESET_SPECIAL = exports.IB_RESET_SPECIAL = "IB_RESET_SPECIAL";
var IB_SET_SPECIAL = exports.IB_SET_SPECIAL = "IB_SET_SPECIAL";
var IB_SET_STATE = exports.IB_SET_STATE = "IB_SET_STATE";
/**
 * Empty, used to be REELS_STOPPING but we cant have that be preset.
 */
var IB_STOPPING = exports.IB_STOPPING = "IB_STOPPING";
var GameInfoBarState = exports.GameInfoBarState = /*#__PURE__*/function (GameInfoBarState) {
  GameInfoBarState[GameInfoBarState["Idle"] = 0] = "Idle";
  GameInfoBarState[GameInfoBarState["Started"] = 1] = "Started";
  GameInfoBarState[GameInfoBarState["Win"] = 2] = "Win";
  GameInfoBarState[GameInfoBarState["Ended"] = 3] = "Ended";
  GameInfoBarState[GameInfoBarState["Special"] = 4] = "Special";
  GameInfoBarState[GameInfoBarState["Empty"] = 5] = "Empty";
  GameInfoBarState[GameInfoBarState["Reconnect"] = 6] = "Reconnect";
  return GameInfoBarState;
}({});
//# sourceMappingURL=types.js.map